<template>
  <div v-if="show" class="row my-3">
    <OrderBump
      v-for="bump in orderBumps"
      :key="bump.id"
      :bump="bump"
    ></OrderBump>
  </div>
</template>

<script>
import _ from 'lodash'
import OrderBump from './OrderBump.vue'

export default {
  components: {
    OrderBump,
  },
  computed: {
    show() {
      if (
        // this.course.is_free ||
        this.course.multiple_licences ||
        this.course.allow_student_to_set_price ||
        this.course.price_variants
      ) {
        return false
      }
      return true
    },
    hasOrderBumps() {
      return !_.isEmpty(this.orderBumps)
    },
    orderBumps() {
      return _.get(this.course, 'order_bumps', []).filter((bump) => (bump.course))
    },
    course() {
      return this.$store.state.course
    },
    page() {
      return this.$store.state.page
    },
  },
}
</script>

<style></style>
